var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNotification = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 200 200",
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#notification_svg__clip0_104_26)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M145.833 0c-29.866 0-54.166 24.3-54.166 54.167 0 29.866 24.3 54.166 54.166 54.166 29.867 0 54.167-24.3 54.167-54.166C200 24.3 175.7 0 145.833 0zm8.334 72.917c0 3.45-2.8 6.25-6.25 6.25s-6.25-2.8-6.25-6.25V45.833H137.5c-3.45 0-6.25-2.8-6.25-6.25s2.8-6.25 6.25-6.25h10.417c3.45 0 6.25 2.8 6.25 6.25v33.334z",
  fill: "#DD737D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.667 166.667c0 18.41-14.924 33.333-33.334 33.333C64.923 200 50 185.077 50 166.667c0-18.41 14.923-33.334 33.333-33.334 18.41 0 33.334 14.924 33.334 33.334z",
  fill: "#FFD860"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.5 124.867c-.891.032-1.767.133-2.667.133C106.775 125 75 93.225 75 54.167c0-13.725 3.992-26.509 10.776-37.375-.818-.033-1.618-.125-2.443-.125C51.167 16.667 25 42.833 25 75v23.233c0 16.492-7.225 32.059-19.9 42.775A14.544 14.544 0 000 152.083c0 8.043 6.541 14.584 14.583 14.584h137.5c8.043 0 14.584-6.541 14.584-14.584 0-4.267-1.858-8.309-5.183-11.15-5.376-4.55-9.709-10.032-12.984-16.066z",
  fill: "#FFE186"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "notification_svg__clip0_104_26"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h200v200H0z"
})))));
export default SvgNotification;